export default ({ dispatch }, { projectId, actionType }) => {
  if (['added', 'edited', 'deleted'].includes(actionType)) {
    dispatch('project/tasks/changeNotification', Number(projectId));
  }
};
